<template>
  <div class="background-modal">
    <div class="wrapper-modal">
      <div class="wrapper-title">
        <p class="title">Información del evento</p>
        <CloseButton @click="closeModal" />
      </div>

      <div class="wrapper-form">
        <GeneralInput
          v-model:text="name.val"
          :value="name.val"
          :label="'Nombre'"
          :has-error="name.enabled"
          :error="name.errors.length === 0 ? '' : name.errors[0]"
          class="input-full"
        />

        <DatePickerInput
          v-model:text="date.val"
          :value="date.val"
          :label="'Fecha máxima de registro'"
          :has-error="date.enabled"
          :error="date.errors.length === 0 ? '' : date.errors[0]"
        />

        <GeneralInput
          v-model:text="guests.val"
          :value="guests.val"
          :label="'Máximo de invitados por cliente'"
          :has-error="guests.enabled"
          :error="guests.errors.length === 0 ? '' : guests.errors[0]"
        />
      </div>
      <StandardButton
        :buttonLabel="'Guardar'"
        class="margin-button"
        :is-disabled="disabledForm"
        @click="createEditEvent"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, Ref, ref, watch, computed } from "vue";
import GeneralInput from "@/components/commons/controls/GeneralInput.vue";
import { createEditEventValidator } from "@/ux/events/validators/createEditEventValidator";
import CloseButton from "@/components/commons/controls/CloseButton.vue";
import StandardButton from "@/components/commons/controls/StandardButton.vue";
import DatePickerInput from "@/components/commons/controls/DatePickerInput.vue";
import { Event } from "@/business/events/domain/events";

export default defineComponent({
  name: "ModalCreateEditEvent",
  props: {
    event: {
      type: Object as () => Event | null,
      default: null,
    },
  },
  components: {
    GeneralInput,
    CloseButton,
    StandardButton,
    DatePickerInput,
  },

  setup(props, context) {
    const { name, date, guests, successForm, successFormEdit, reset } =
      createEditEventValidator();

    const isEdit: Ref<boolean> = ref(false);

    const formatter = new Intl.DateTimeFormat("en-CA", {
      timeZone: "America/Bogota",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });

    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);

    const minDate: Ref<string> = ref(formatter.format(tomorrow));

    function closeModal() {
      context.emit("close");
    }

    watch(
      () => props.event,
      () => {
        reset();
        if (props.event != null) {
          name.value.val = props.event.name;
          date.value.val = props.event.lastDate;
          guests.value.val = props.event.maxInvites.toString();
          isEdit.value = true;
        } else {
          isEdit.value = false;
        }
      }
    );

    function createEvent() {
      const newEventForm = {
        name: name.value.val,
        date: date.value.val,
        guests: guests.value.val,
      };

      context.emit("create", newEventForm);
    }

    function editEvent() {
      const editEventForm = {
        name: name.value.val,
        date: date.value.val,
        guests: guests.value.val,
      };

      context.emit("edit", editEventForm);
    }

    function createEditEvent() {
      if (!isEdit.value) {
        createEvent();
      } else {
        editEvent();
      }
    }

    const disabledForm = computed(() => {
      return isEdit.value ? successFormEdit.value : successForm.value;
    });

    return {
      closeModal,
      name,
      date,
      guests,
      successForm,
      successFormEdit,
      reset,
      createEditEvent,
      disabledForm,
      minDate,
    };
  },
});
</script>

<style scoped lang="scss">
@import "src/ux/events/styles/modalCreateEditEventStyle";
</style>
